import type { OnPaginateAction } from '@rover/react-lib/src/components/lists/Carousel/utils/onPaginateEvent.types';
import type { ServiceTypeSlugEnum } from '@rover/rsdk/src/apiClient/latest/model/serviceTypeSlugEnum';
import { emitAnalyticsEvent } from '@rover/rsdk/src/modules/Analytics';
import { storeCrossPageAnalyticsEvent } from '@rover/utilities/fireCrossPageEvent';

import {
  CarouselPaginateAction,
  ClickSitterCard,
  SearchResultLayoutType,
  SearchResultsCtaClick,
  SitterCardType,
  ViewSitterCard,
} from './analyticsEvents';

type CarouselAnalyticsHandlers = {
  onPaginate: OnPaginateAction;
  onSearchResultCardClick: () => void;
  onSearchResultCardViewed: (personOpk: string) => void;
  onCtaPress: () => void;
};

const getCarouselAnalyticsHandlers = (
  serviceTypeSlug: ServiceTypeSlugEnum
): CarouselAnalyticsHandlers => ({
  onPaginate: ({ pageStart, pageEnd, scrollSource }) => {
    emitAnalyticsEvent(
      new CarouselPaginateAction({ serviceTypeSlug, pageStart, pageEnd, scrollSource })
    );
  },
  onSearchResultCardClick: () => {
    storeCrossPageAnalyticsEvent(
      new ClickSitterCard({ serviceTypeSlug, cardType: SitterCardType.CAROUSEL })
    );
  },
  onSearchResultCardViewed: (personOpk) => {
    emitAnalyticsEvent(
      new ViewSitterCard({
        serviceTypeSlug,
        cardType: SitterCardType.CAROUSEL,
        sitterResultPersonOpk: personOpk,
      })
    );
  },
  onCtaPress: () => {
    storeCrossPageAnalyticsEvent(
      new SearchResultsCtaClick({ serviceTypeSlug, layoutType: SearchResultLayoutType.CAROUSEL })
    );
  },
});

export default getCarouselAnalyticsHandlers;
